<p>transcript-overlay works!</p>
<div class="ts-panel" aria-live="polite">

    <!-- Recording state -->
    @if (recording) {
    <div class="ts-overlay">
        <div class="ts-orb">
            <i class="ts-ring"></i>
            <i class="ts-ring r2"></i>
            <i class="ts-ring r3"></i>

            <div class="ts-core">
                <div class="ts-eq">
                    <i></i><i></i><i></i><i></i><i></i>
                </div>
            </div>
        </div>

        <div class="ts-title">
            Listening<span class="ts-dots"><b>.</b><b>.</b><b>.</b></span>
        </div>

        <div class="ts-msgs">
            <p>Speak naturally. I'm capturing every detail.</p>
            <p>Pauses are fine. I'll keep listening.</p>
            <p>Your transcript is being captured in the background..</p>
        </div>
    </div>
    }@else{
    <div class="ts-overlay ts-empty">
        @if(!hasTranscript){
        <div class="ts-title">Welcome to Your AI-Powered Consultation!</div>
        <p class="ts-sub">
            Ready? Click the mic icon to get started.
        </p>
        }@else {
        <div class="ts-orb">
            <i class="ts-ring"></i>
            <div class="ts-core"><mat-icon>check</mat-icon></div>
        </div>
        <div class="ts-title">Your Transcript Is Ready!</div>
        <div class="ts-msgs">
            <p>Select <strong>Generate</strong> to create clinical notes, letters, or documents using your default
                template.</p>
            <p>Want a different format? Select <strong>Generate</strong> to explore available templates.</p>
            <p>Need to add more details? Click the <strong>microphone</strong> icon to continue recording your
                consultation.</p>
        </div>
        }


    </div>
    }
</div>